import { render } from "./resetPass.vue?vue&type=template&id=518213ba&scoped=true"
import script from "./resetPass.vue?vue&type=script&lang=js"
export * from "./resetPass.vue?vue&type=script&lang=js"

import "./resetPass.vue?vue&type=style&index=0&id=518213ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518213ba"]])

export default __exports__